import { isApple } from './is-apple.js';

const MODIFIERS = {
  alt: () => "altKey",
  ctrl: () => "ctrlKey",
  meta: () => "metaKey",
  mod: () => isApple() ? "metaKey" : "ctrlKey",
  shift: () => "shiftKey"
};
function isKey(event, key, modifiers = {}) {
  if (event.key !== key) {
    return false;
  }
  const explicitModifiers = Object.entries(modifiers).filter(
    ([, value]) => typeof value === "boolean"
  );
  return explicitModifiers.every(([modifier, value]) => {
    const property = MODIFIERS[modifier]();
    return event[property] === value;
  });
}

export { isKey };
//# sourceMappingURL=is-key.js.map
